// extracted by extract-css-chunks-webpack-plugin
module.exports = {"button":"app-components-usersongs-song-actionbutton--button","mobileHidden":"app-components-usersongs-song-actionbutton--mobileHidden"};